module.exports = __webpack_public_path__ + "static/media/news_menu_blue.442e6c58.svg";